// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.mailbox-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.mailbox-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  pointer-events: auto;
  width: clamp(440px, 34vw, 580px);
  max-height: 82vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: ink-enter 0.16s ease-out;
}
.mailbox-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .mailbox-panel {
    animation: none;
  }
}

.mailbox-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 24px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.mailbox-header-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}

.mailbox-body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  scrollbar-gutter: stable;
}
.mailbox-body::-webkit-scrollbar {
  width: 6px;
}
.mailbox-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.mailbox-body--menu {
  align-items: stretch;
  justify-content: center;
  gap: 0;
  padding: 12px 24px;
}

.mailbox-tile {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #ebe8e1;
  text-align: left;
  background: transparent;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  border-left: 2px solid transparent;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.mailbox-tile:first-child {
  border-top-color: transparent;
}
.mailbox-tile-label {
  flex: 1 1 auto;
}
.mailbox-tile:hover {
  background: rgba(255, 255, 255, 0.04);
  border-left-color: var(--gold-main);
  color: var(--gold-light);
}
.mailbox-tile:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}

.mailbox-list {
  display: flex;
  flex-direction: column;
}

.mailbox-empty {
  padding: 18px 0;
  font-size: 14px;
  color: #8d8a82;
}

.mailbox-letter {
  padding: 12px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.mailbox-letter-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}
.mailbox-letter-from {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--gold-light);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mailbox-letter-date {
  flex-shrink: 0;
  font-size: 13px;
  color: #8d8a82;
  font-variant-numeric: tabular-nums;
}
.mailbox-letter-text {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #ebe8e1;
  white-space: pre-wrap;
}

.mailbox-letter-gold {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}
.mailbox-letter-gold-amount {
  font-size: 14px;
  font-weight: 600;
  color: var(--gold-light);
}
.mailbox-letter-gold--claimed {
  justify-content: flex-start;
  font-size: 13px;
  color: #8d8a82;
}

.mailbox-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  padding: 0;
  font-size: 18px;
  line-height: 1;
}
.mailbox-icon-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.mailbox-icon-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.mailbox-icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.mailbox-icon-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.mailbox-icon-btn:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.mailbox-icon-btn:hover:not(:disabled) {
  color: #d9786d;
  background: rgba(217, 120, 109, 0.14);
}

.mailbox-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.mailbox-field-label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}

.mailbox-autocomplete {
  position: relative;
  display: block;
  width: 100%;
}

.mailbox-autocomplete-list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 10;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  max-height: 200px;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}
.mailbox-autocomplete-list::-webkit-scrollbar {
  width: 6px;
}
.mailbox-autocomplete-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.mailbox-autocomplete-item {
  padding: 8px 12px;
  font-size: 14px;
  color: #ebe8e1;
  border-left: 2px solid transparent;
  cursor: pointer;
}
.mailbox-autocomplete-item:hover {
  background: rgba(255, 255, 255, 0.04);
  border-left-color: var(--gold-main);
  color: var(--gold-light);
}

.mailbox-input,
.mailbox-textarea {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  display: block;
}
.mailbox-input:focus,
.mailbox-textarea:focus {
  outline: none;
  border-color: var(--gold-main);
}
.mailbox-input::placeholder,
.mailbox-textarea::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}

.mailbox-textarea {
  min-height: 160px;
  line-height: 1.5;
  resize: vertical;
}

.mailbox-compose-hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}

.mailbox-pending-hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.mailbox-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}

.mailbox-close-row {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.mailbox-hint {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8d8a82;
}
.mailbox-hint kbd {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 12px;
  padding: 2px 8px;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
}

.mailbox-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.mailbox-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.mailbox-button:active:not(:disabled) {
  transform: translateY(1px);
}
.mailbox-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.mailbox-button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.mailbox-button:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.mailbox-button--ghost, .mailbox-button--gold {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.2);
}
.mailbox-button--ghost:hover:not(:disabled), .mailbox-button--gold:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.mailbox-button--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.mailbox-button--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.mailbox-button--gold {
  padding: 5px 10px;
  font-size: 13px;
}

.mailbox-seal {
  display: inline-block;
  flex: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}
.mailbox-seal--broken {
  opacity: 0.55;
  clip-path: polygon(0 0, 55% 0, 45% 40%, 100% 55%, 100% 100%, 0 100%);
}

.mailbox-letter-sealed {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
}

.mailbox-letter-sealed-text {
  flex: 1;
}

.mailbox-letter-seal-broken {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  opacity: 0.8;
  margin-bottom: 4px;
}

.mailbox-field--check {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/mailbox/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AALA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDiBU;ACVZ;;AAJA;EDiBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EC3BA,oBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EDuJA,mCAAA;ACzIF;ADFE;EAAI,sBAAA;ACKN;ADwIE;EChKF;IDgK4C,eAAA;ECpI1C;AACF;;AAlBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,kDAAA;AAqBF;AAnBE;EDqBA,kDA3BW;EA4BX,gBAAA;EACA,eCtBqB;EDuBrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ACyCP;;AAtBA;ED6HE,gBAAA;EACA,qBAAA;EACA,qDAAA;EC7HA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wBAAA;AA2BF;AD8FE;EAAuB,UAAA;AC3FzB;AD4FE;EAA6B,oCAAA;EAAsC,kBAAA;ACxFrE;;AA/BA;EACE,oBAAA;EACA,uBAAA;EACA,MAAA;EACA,kBAAA;AAkCF;;AA9BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yDDlCU;ECmCV,eAAA;EACA,gBAAA;EACA,cD9CK;EC+CL,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,+CAAA;EACA,kCAAA;EACA,eAAA;EACA,kFAAA;AAiCF;AA/BE;EAAgB,6BAAA;AAkClB;AAhCE;EACE,cAAA;AAkCJ;AA/BE;EACE,qCDlES;ECmET,mCAAA;EACA,wBAAA;AAiCJ;AA9BE;EACE,oCAAA;EACA,oBAAA;AAgCJ;;AA5BA;EACE,aAAA;EACA,sBAAA;AA+BF;;AA5BA;EACE,eAAA;EACA,eAAA;EACA,cD/EO;AC8GT;;AA5BA;EACE,eAAA;EACA,+CAAA;AA+BF;AA7BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA+BJ;AA5BE;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA8BJ;AA3BE;EACE,cAAA;EACA,eAAA;EACA,cD3GK;EC4GL,kCAAA;AA6BJ;AA1BE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDrHG;ECsHH,qBAAA;AA4BJ;;AAxBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AA2BF;AAzBE;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AA2BJ;AAxBE;EACE,2BAAA;EACA,eAAA;EACA,cDxIK;ACkKT;;AAtBA;ED/EE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;ECwCA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AA0CF;ADhHE;EAAyB,qCAAA;EAAuC,8BAAA;ACoHlE;ADnHE;EAA0B,0BAAA;ACsH5B;ADrHE;EAAa,YAAA;EAAc,mBAAA;ACyH7B;ADxHE;EAAkB,oCAAA;EAAsC,mBAAA;AC4H1D;ADpGE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACyGhF;AA5DE;EAAyB,cDrJlB;ECqJsC,qCAAA;AAgE/C;;AA7DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAgEF;AA9DE;EDxGA,eAAA;EACA,gBAAA;EACA,cAzDO;ACkOT;;AA9DA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;AAiEF;;AA9DA;ED3BE,gBAAA;EACA,qBAAA;EACA,qDAAA;EC2BA,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCD3LI;EC4LJ,0CAAA;EACA,kBDnLO;ECoLP,0CAAA;AAmEF;ADxGE;EAAuB,UAAA;AC2GzB;AD1GE;EAA6B,oCAAA;EAAsC,kBAAA;AC8GrE;;AAvEA;EACE,iBAAA;EACA,eAAA;EACA,cD/LK;ECgML,kCAAA;EACA,eAAA;AA0EF;AAxEE;EACE,qCDxMS;ECyMT,mCAAA;EACA,wBAAA;AA0EJ;;AAtEA;;EDtFE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECiFA,cAAA;AAiFF;ADhKE;;EAAU,aAAA;EAAe,8BAAA;ACqK3B;ADpKE;;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC4K1G;;AA3FA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AA8FF;;AA3FA;EDpKE,eAAA;EACA,gBAAA;EACA,cAlDO;ACqTT;;AA7FA;EDxKE,eAAA;EACA,gBAAA;EACA,cAlDO;EC0NP,iBAAA;EACA,+CAAA;AAkGF;;AA/FA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AAkGF;;AA/FA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,+CAAA;AAkGF;;AA/FA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cDpPO;ACsVT;AAhGE;EACE,yDDhPQ;ECiPR,eAAA;EACA,gBAAA;EACA,cD3PK;EC4PL,qCDjQS;ECkQT,2CAAA;EACA,kBAAA;AAkGJ;;AA7FA;EDrME,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC8RF;ADvSE;EAAyB,qCAAA;EAAuC,8BAAA;AC2SlE;AD1SE;EAA0B,0BAAA;AC6S5B;AD5SE;EAAa,YAAA;EAAc,mBAAA;ACgT7B;AD/SE;EAAkB,oCAAA;EAAsC,mBAAA;ACmT1D;AD3SE;EAAyB,6BAAA;EAA+B,+BAAA;AC+S1D;AAlIE;EAEE,cD1QG;EC2QH,qCAAA;EACA,sCD7QU;ACgZd;AAjII;EACE,cD/QC;ECgRD,qCAAA;EACA,8BAAA;AAmIN;AA/HE;ED9KA,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACgTF;AD9SE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACmThF;AArIE;ED1KA,iBAAA;EACA,eAAA;ACkTF;;AApIA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,wCAAA;AAuIF;AArIE;EACE,aAAA;EACA,oEAAA;AAuIJ;;AAnIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAsIF;;AAnIA;EACE,OAAA;AAsIF;;AAnIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAsIF;;AAnIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAsIF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Mailbox. Centred modal, ink panel look shared with the escape menu and the\n// housing drawer (see theme/_ink.scss).\n@use '../../theme/ink' as ink;\n\n.mailbox-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 8, 0.6);\n  pointer-events: none;\n  font-family: ink.$font-text;\n}\n\n.mailbox-panel {\n  @include ink.panel;\n  pointer-events: auto;\n  width: clamp(440px, 34vw, 580px);\n  max-height: 82vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  @include ink.enter;\n}\n\n.mailbox-header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 18px 24px 14px;\n  border-bottom: 1px solid ink.$line;\n\n  &-title {\n    @include ink.title(26px);\n  }\n}\n\n.mailbox-body {\n  @include ink.scroll;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  scrollbar-gutter: stable;\n}\n\n.mailbox-body--menu {\n  align-items: stretch;\n  justify-content: center;\n  gap: 0;\n  padding: 12px 24px;\n}\n\n// Menu entries: rows with a single top divider, accent bar on hover/focus.\n.mailbox-tile {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 12px;\n  font-family: ink.$font-text;\n  font-size: 16px;\n  font-weight: 600;\n  color: ink.$text;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-top: 1px solid ink.$line;\n  border-left: 2px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:first-child { border-top-color: transparent; }\n\n  &-label {\n    flex: 1 1 auto;\n  }\n\n  &:hover {\n    background: ink.$ink-raised;\n    border-left-color: var(--gold-main);\n    color: var(--gold-light);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--gold-light);\n    outline-offset: -2px;\n  }\n}\n\n.mailbox-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.mailbox-empty {\n  padding: 18px 0;\n  font-size: 14px;\n  color: ink.$text-3;\n}\n\n.mailbox-letter {\n  padding: 12px 0;\n  border-top: 1px solid ink.$line;\n\n  &-head {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 6px;\n  }\n\n  &-from {\n    flex: 1 1 auto;\n    min-width: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--gold-light);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &-date {\n    flex-shrink: 0;\n    font-size: 13px;\n    color: ink.$text-3;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &-text {\n    margin: 0;\n    font-size: 15px;\n    line-height: 1.5;\n    color: ink.$text;\n    white-space: pre-wrap;\n  }\n}\n\n.mailbox-letter-gold {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 10px;\n\n  &-amount {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--gold-light);\n  }\n\n  &--claimed {\n    justify-content: flex-start;\n    font-size: 13px;\n    color: ink.$text-3;\n  }\n}\n\n.mailbox-icon-btn {\n  @include ink.button;\n  @include ink.button-quiet;\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  padding: 0;\n  font-size: 18px;\n  line-height: 1;\n\n  &:hover:not(:disabled) { color: ink.$danger; background: rgba(217, 120, 109, 0.14); }\n}\n\n.mailbox-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  &-label {\n    @include ink.label;\n  }\n}\n\n.mailbox-autocomplete {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.mailbox-autocomplete-list {\n  @include ink.scroll;\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 10;\n  margin: 0;\n  padding: 4px 0;\n  list-style: none;\n  max-height: 200px;\n  background: ink.$ink;\n  border: 1px solid ink.$line-strong;\n  border-radius: ink.$radius;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);\n}\n\n.mailbox-autocomplete-item {\n  padding: 8px 12px;\n  font-size: 14px;\n  color: ink.$text;\n  border-left: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover {\n    background: ink.$ink-raised;\n    border-left-color: var(--gold-main);\n    color: var(--gold-light);\n  }\n}\n\n.mailbox-input,\n.mailbox-textarea {\n  @include ink.field;\n  display: block;\n}\n\n.mailbox-textarea {\n  min-height: 160px;\n  line-height: 1.5;\n  resize: vertical;\n}\n\n.mailbox-compose-hint {\n  @include ink.hint;\n}\n\n.mailbox-pending-hint {\n  @include ink.hint;\n  padding-top: 10px;\n  border-top: 1px solid ink.$line;\n}\n\n.mailbox-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.mailbox-close-row {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 24px;\n  border-top: 1px solid ink.$line;\n}\n\n.mailbox-hint {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: ink.$text-3;\n\n  kbd {\n    font-family: ink.$font-text;\n    font-size: 12px;\n    padding: 2px 8px;\n    color: ink.$text-2;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-radius: 4px;\n  }\n}\n\n// Primary by default; --ghost neutral, --quiet tertiary, --gold small neutral.\n.mailbox-button {\n  @include ink.button;\n  @include ink.button-primary;\n\n  &--ghost,\n  &--gold {\n    color: ink.$text;\n    background: rgba(255, 255, 255, 0.07);\n    border-color: ink.$line-strong;\n\n    &:hover:not(:disabled) {\n      color: ink.$text;\n      background: rgba(255, 255, 255, 0.12);\n      border-color: var(--gold-dark);\n    }\n  }\n\n  &--quiet {\n    @include ink.button-quiet;\n  }\n\n  &--gold {\n    @include ink.button-sm;\n  }\n}\n\n.mailbox-seal {\n  display: inline-block;\n  flex: none;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);\n\n  &--broken {\n    opacity: 0.55;\n    clip-path: polygon(0 0, 55% 0, 45% 40%, 100% 55%, 100% 100%, 0 100%);\n  }\n}\n\n.mailbox-letter-sealed {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n}\n\n.mailbox-letter-sealed-text {\n  flex: 1;\n}\n\n.mailbox-letter-seal-broken {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  opacity: 0.8;\n  margin-bottom: 4px;\n}\n\n.mailbox-field--check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-direction: row;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
